import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/battery.jpg';
import Video from '../../assets/battery.mp4';
import BatterySection2Image2 from '../../assets/battery_section2_image2.png';
import BatterySection2Image3 from '../../assets/battery_section2_image3.png';
import { CenterLayout, HorizontalEqualLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, H4, H7 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const SecondaryBatterySection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(166)}`} />
      <CenterLayout>
        <H4 style={{ textAlign: 'center' }}><Trans i18nKey='더 오래, 더 강하게, 더 빠르게, 차세대 배터리 기술의 진화를 이끌고 있습니다.'/></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(55)}`} />
      {isMobile ? (
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: '400px',
            display: 'block',
            objectFit: 'cover',
          }}
        />
      ) : (
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
      )}
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      <CenterLayout>
        <H4><Trans i18nKey='지속 가능한 에너지를 위한 핵심 인프라'/></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : `${pxToRem(55)}`} />
      <CenterLayout>
        <Body1 style={{ textAlign: 'center' }}><Trans i18nKey='비비테크는 전기차, 에너지 저장장치(ESS), 모바일 기기 등 다양한 산업에 적용되는 이차 전지 설비와 솔루션을 제공합니다. 고효율·고안정성을 바탕으로, 배터리 생산 공정의 정밀성과 품질을 한층 더 끌어올립니다.'/></Body1>
      </CenterLayout>

      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      <HorizontalEqualLayout
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '8px' : `${pxToRem(40)}`,
          width: '100%',
        }}
      >
        <VerticalLayout style={{ flex: 1 }}>
          <img src={BatterySection2Image2} style={{ width: '100%' }} />
        </VerticalLayout>

        <VerticalLayout style={{ flex: 1 }}>
          <img src={BatterySection2Image3} style={{ width: '100%' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 30 : pxToRem(127)} />
      <CenterLayout>
        <H7 style={{ textAlign: 'center' }}>
          <Trans i18nKey='비비테크는 배터리 제조 공정에 필수적인 유틸리티 배관 시스템을 설계, 제작, 시공, 유지보수까지 One-Stop Service로 제공합니다.'/>
        </H7>
      </CenterLayout>

      <BTBox height={isMobile ? 24 : pxToRem(55)} />

      <CenterLayout>
        <Body1 style={{ textAlign: 'center' }}>
          <Trans i18nKey='정밀성, 고내식성, 고효율을 요구하는 생산 환경에 최적화된 맞춤형 배관 솔루션을 통해 공정 안정성과 생산 효율을 동시에 실현합니다.'/>
        </Body1>
      </CenterLayout>

      <BTBox height={isMobile ? 89 : pxToRem(165)} />
    </VerticalLayout>
  );
};

export default SecondaryBatterySection2;
